import { Component, OnInit } from '@angular/core';
import{FormGroup, FormControl,Validators, AbstractControl}from '@angular/forms'
import {ScholarService}from'../../services/scholar.service';
import Swal from 'sweetalert2';
import{bounceInX}from'../../../shared/animation/animation'
import { transition, trigger } from '@angular/animations';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
@Component({
  selector: 'app-signupscholar',
  templateUrl: './signupscholar.component.html',
  styleUrls: ['./signupscholar.component.css'],
  animations:[trigger('bounceInX',[transition(':enter',[bounceInX])])]
})
export class SignupscholarComponent implements OnInit {
  disabled:boolean=false;
  form:FormGroup;
  currentYear:String;
  constructor(private SignUp:ScholarService,private router:Router) { 
    this.createForm()
  }
  ngOnInit() {
               const currentDateTime = new Date();
        const formattedDate = currentDateTime.toISOString().split("T")[0];

        // // Format the current time as 'HH:mm AM/PM'
        // const formattedTime = currentDateTime.toLocaleTimeString([], {
        //   hour: "2-digit",
        //   minute: "2-digit",
        //   hour12: true,
        // });
    this.currentYear = formattedDate 
  }
  createForm(){
      this.form=new FormGroup({
      firstName:new FormControl(null,[Validators.required,Validators.maxLength(50),this.trim.bind(this),Validators.pattern(/^[a-z]+$/i)]),
      lastName:new FormControl(null,[Validators.required,Validators.maxLength(50),this.trim.bind(this),Validators.pattern(/^[a-z]+$/i)]),
      enrolledProgram:new FormControl(null,[Validators.required,Validators.maxLength(50)]),
      scholarSince:new FormControl(null),
      email : new FormControl(null, [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
      phone:new FormControl(null,[Validators.required,Validators.pattern(/^[0-9]{10}$/)]),
      // bestTimeToContact:new FormControl(null,[Validators.required,Validators.maxLength(50),Validators.pattern(/^([0][1-9]|[1][0-2]):([0-5][0-9])(AM|PM)$/)]),
      bestTimeToContact:new FormControl(null,[Validators.required,Validators.maxLength(50)]),
      password:new FormControl(null,[Validators.required,Validators.minLength(8),Validators.maxLength(255),this.trim.bind(this), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]),
    })
  }
   //get reference of different form elements//
    get Fname(){
    return this.form.get('firstName')
             }
    get Lname(){
    return this.form.get('lastName')
             }
    get ScholarSince(){
    return this.form.get('scholarSince')
             } 
    get Email(){
    return this.form.get('email')
             }
    get Phone(){
    return this.form.get('phone')
             }
    get BestTimeToContact(){
    return this.form.get('bestTimeToContact')
             } 
    get Password(){
    return this.form.get('password')
             }
    get EnrolledProgram(){
    return this.form.get('enrolledProgram')
            }  
                 
    reSet(){
      this.router.navigate(['/'])
    }
  onSubmit(){
    this.form.get('scholarSince').setValue(this.currentYear);
            if(this.form.valid)
            {
               this.SignUp.register(this.form.value).subscribe(
                 (result)=>{
                  this.disabled=true;
                   Swal.fire({
                     title:'Registered Sucessfully ',
                     text:'Your account is being reviewed, and you’ll be notified by email once approved',
                     type:"success"
                   }).then((result)=>{
                    if(result.value ===true){
                      this.router.navigate(['/login/scholar']);
                    }
                   })
                                 
                  },
                 (err)=>{
                   if(err.status===400){
                      Swal.fire({
                        title:err.error.error,
                        type:"error"
                      })
                      this.disabled=false;
                      throw new HttpErrorResponse({});
                   }
                   
                 })
            }
            else {
              return false
            }
 }             

 trim(control:AbstractControl){
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'whitespace': true };
      

}
        
      
}
